export const textStyles = {
  h1: "text-4xl",
  h2: "text-3xl",
  h3: "text-2xl",
  h4: "text-xl",
  h5: "text-lg",
  p: "text-base",
};

export const alignStyles = {
  left: "text-left",
  center: "text-center",
  right: "text-right",
  justify: "text-justify",
};

const Text = ({
  variant = "p",
  bold = false,
  align = "left",
  className = "",
  children,
}) => {
  const baseStyle = textStyles[variant] || textStyles.p;
  const weightStyle = bold ? "font-bold" : "font-normal";
  const alignStyle = alignStyles[align] || alignStyles.left;

  const Tag = variant;

  return (
    <Tag className={`capitalize ${baseStyle} ${weightStyle} ${alignStyle} ${className}`}>
      {children}
    </Tag>
  );
};

export default Text;
